var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Error-Dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Error-Dark"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6-Copy-23",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48337209,18.1857781 C4.34894187,18.422622 4.3080623,18.3543956 4.60636607,18.3543956 L19.3938234,18.3543956 C19.6915438,18.3543956 19.6508707,18.4220896 19.5167492,18.1858127 L12.0717847,5.0702954 C11.9395559,4.83735287 12.0597751,4.83740712 11.9276096,5.07026087 L4.48337209,18.1857781 Z M13.7251646,4.13619078 L21.1701291,17.251708 C22.0279681,18.7629311 21.1344818,20.25 19.3938234,20.25 L4.60636607,20.25 C2.86387851,20.25 1.97253165,18.7623774 2.829953,17.2517426 L10.2741905,4.13622532 C11.1342893,2.62087338 12.8654449,2.62165464 13.7251646,4.13619078 Z M11.9999942,17.1696429 C12.4722208,17.1696429 12.8550361,16.7877319 12.8550361,16.3166209 C12.8550361,15.8455099 12.4722208,15.4635989 11.9999942,15.4635989 C11.5277676,15.4635989 11.1449523,15.8455099 11.1449523,16.3166209 C11.1449523,16.7877319 11.5277676,17.1696429 11.9999942,17.1696429 Z M11.0499477,9.49244511 L11.0499477,13.757555 C11.0499477,14.2810117 11.475298,14.7053572 11.9999942,14.7053572 C12.5246904,14.7053572 12.9500407,14.2810117 12.9500407,13.757555 L12.9500407,9.49244511 C12.9500407,8.96898841 12.5246904,8.54464291 11.9999942,8.54464291 C11.475298,8.54464291 11.0499477,8.96898841 11.0499477,9.49244511 Z",
    id: "Warning",
    fill: "#394152",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0df39bb3.svg";
export { ForwardRef as ReactComponent };